/* eslint-disable arrow-body-style */
import React from "react"
import { useTranslation } from "next-i18next"
import Link from "next/dist/client/link"
import Image from "next/dist/client/image"
import { FaAngleRight } from "react-icons/fa"
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from "@cs/components/ui/dialog"
import { useUser } from "@cs/components/hooks/useUser"
import styles from "./SignInDialog.module.scss"
import { useAccountRedirect } from "@cs/components/hooks/useAccountRedirect"
import ProgressEarthly from "@cs/public/img/earthlies/progress_earthly.png"
import { MixpanelService } from "@cs/services/mixpanel"
import { Button } from "../ui/button"

export const SignInDialog = ({
  redirectUrl,
  allowSkip = false,
  children,
}: {
  redirectUrl: string
  allowSkip?: boolean
  children: React.ReactNode
}) => {
  const { t } = useTranslation("nav")
  const { user } = useUser()
  const { accountRedirect } = useAccountRedirect()

  const trackAndRedirectSignup = () => {
    MixpanelService.clickRegister("v6")
  }

  return (
    <Dialog>
      {user ? (
        <Link href={redirectUrl}>{children}</Link>
      ) : (
        <DialogTrigger asChild>{children}</DialogTrigger>
      )}
      <DialogContent className={styles.content}>
        <figure className={styles.earthly}>
          <Image
            src={ProgressEarthly}
            alt="Progress Earthly"
            width={160 * 1.4}
            height={212 * 1.4}
          />
        </figure>
        <DialogHeader className={styles.header}>
          <DialogTitle className={styles.title}>
            {t("save-your-progress", { ns: "common" })}
          </DialogTitle>
          <p className={styles.p}>{t("set-free-account", { ns: "common" })}</p>
        </DialogHeader>
        <DialogDescription className={styles.description}>
          <DialogFooter className={styles.buttons}>
            <Link href={accountRedirect("sign-up")} passHref>
              <Button asChild className={styles.button}>
                <a onClick={() => trackAndRedirectSignup}>
                  {t("sign-up")} <FaAngleRight fontSize="24px" />
                </a>
              </Button>
            </Link>
            {allowSkip && (
              <Link href={redirectUrl}>
                <Button light asChild className={styles.button}>
                  <a>Skip</a>
                </Button>
              </Link>
            )}
          </DialogFooter>
        </DialogDescription>
      </DialogContent>
    </Dialog>
  )
}
